/**
 * DeliverFresh Wishlist Module
 * Uses localStorage to persist wishlisted product handles.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'df_wishlist';

  /* ── Core helpers ── */

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  }

  function addToWishlist(handle) {
    var list = getWishlist();
    if (list.indexOf(handle) === -1) {
      list.push(handle);
      saveWishlist(list);
    }
    updateWishlistCount();
    syncHeartButtons();
  }

  function removeFromWishlist(handle) {
    var list = getWishlist().filter(function (h) {
      return h !== handle;
    });
    saveWishlist(list);
    updateWishlistCount();
    syncHeartButtons();
  }

  function isInWishlist(handle) {
    return getWishlist().indexOf(handle) !== -1;
  }

  /* ── Badge / count ── */

  function updateWishlistCount() {
    var count = getWishlist().length;
    var badges = document.querySelectorAll('.df-wishlist-count');
    badges.forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'inline-flex' : 'none';
    });
  }

  /* ── Heart button sync (product pages) ── */

  function syncHeartButtons() {
    var btns = document.querySelectorAll('.df-wishlist-btn');
    btns.forEach(function (btn) {
      var handle = btn.getAttribute('data-handle');
      if (!handle) return;
      var inList = isInWishlist(handle);
      btn.classList.toggle('df-wishlist-btn--active', inList);
      var textEl = btn.querySelector('.df-wishlist-text');
      if (textEl) {
        textEl.textContent = inList ? 'In Wishlist' : 'Add to Wishlist';
      }
    });
  }

  /* ── Toggle (called from onclick on product pages) ── */

  window.toggleWishlist = function (btn) {
    var handle = btn.getAttribute('data-handle');
    if (!handle) return;
    if (isInWishlist(handle)) {
      removeFromWishlist(handle);
    } else {
      addToWishlist(handle);
    }
  };

  /* ── Wishlist page rendering ── */

  function renderWishlistPage() {
    var container = document.getElementById('df-wishlist-grid');
    var emptyState = document.getElementById('df-wishlist-empty');
    if (!container) return; // not on wishlist page

    var handles = getWishlist();

    if (handles.length === 0) {
      container.style.display = 'none';
      if (emptyState) emptyState.style.display = 'block';
      return;
    }

    if (emptyState) emptyState.style.display = 'none';
    container.style.display = 'grid';
    container.innerHTML = '<div class="df-wishlist-loading">Loading your wishlist...</div>';

    var fetches = handles.map(function (handle) {
      return fetch('/products/' + handle + '.json')
        .then(function (res) {
          if (!res.ok) throw new Error('Not found');
          return res.json();
        })
        .then(function (data) {
          return data.product;
        })
        .catch(function () {
          return null;
        });
    });

    Promise.all(fetches).then(function (products) {
      products = products.filter(Boolean);
      if (products.length === 0) {
        container.style.display = 'none';
        if (emptyState) emptyState.style.display = 'block';
        return;
      }

      container.innerHTML = '';
      products.forEach(function (product) {
        var variant = product.variants[0];
        var imgSrc = product.image
          ? product.image.src
          : '';
        var price = (variant.price / 1).toLocaleString('en-AU', {
          style: 'currency',
          currency: 'AUD',
        });

        var card = document.createElement('div');
        card.className = 'df-wishlist-card';
        card.innerHTML =
          '<a href="/products/' + product.handle + '" class="df-wishlist-card-img">' +
            (imgSrc
              ? '<img src="' + imgSrc + '" alt="' + product.title + '" loading="lazy">'
              : '<div class="df-wishlist-no-img">No image</div>') +
          '</a>' +
          '<div class="df-wishlist-card-body">' +
            '<a href="/products/' + product.handle + '" class="df-wishlist-card-title">' + product.title + '</a>' +
            '<div class="df-wishlist-card-price">' + price + '</div>' +
            '<div class="df-wishlist-card-actions">' +
              '<form method="post" action="/cart/add">' +
                '<input type="hidden" name="id" value="' + variant.id + '">' +
                '<input type="hidden" name="quantity" value="1">' +
                '<button type="submit" class="df-wishlist-atc-btn">Add to Cart</button>' +
              '</form>' +
              '<button class="df-wishlist-remove-btn" data-handle="' + product.handle + '">Remove</button>' +
            '</div>' +
          '</div>';

        card.querySelector('.df-wishlist-remove-btn').addEventListener('click', function () {
          removeFromWishlist(product.handle);
          card.remove();
          // Check if empty after removal
          if (getWishlist().length === 0) {
            container.style.display = 'none';
            if (emptyState) emptyState.style.display = 'block';
          }
        });

        container.appendChild(card);
      });
    });
  }

  /* ── Init ── */

  document.addEventListener('DOMContentLoaded', function () {
    updateWishlistCount();
    syncHeartButtons();
    renderWishlistPage();
  });

  /* ── Expose globally ── */
  window.dfWishlist = {
    add: addToWishlist,
    remove: removeFromWishlist,
    get: getWishlist,
    isIn: isInWishlist,
  };
})();
